import React from 'react';
import { CSSProperties, FC, SVGProps } from 'react';

export const Dot: FC<
    {
        fillColor?: string;
        strokeColor?: string;
        strokeWidth?: number;
        radius: number;
        centerX?: number;
        centerY?: number;
    } & SVGProps<SVGSVGElement>
> = ({ fillColor, strokeColor, strokeWidth, radius, centerX, centerY, style, ...props }) => {
    const size = radius * 2;
    const baseStyle: CSSProperties = {
        overflow: 'visible',
    };
    if (centerX !== undefined && centerY !== undefined) {
        Object.assign(baseStyle, {
            position: 'absolute',
            left: centerX - radius,
            top: centerY - radius,
        });
    }
    return (
        <svg
            width={size}
            height={size}
            display='block'
            viewBox={`0 0 ${size} ${size}`}
            style={{ ...baseStyle, ...style }}
            {...props}
        >
            <circle
                cx={radius}
                cy={radius}
                r={radius}
                fill={fillColor}
                stroke={strokeColor}
                strokeWidth={strokeWidth}
            />
        </svg>
    );
};

